import type { HandshakeMessagePublic } from "@/types";
import { SystemMessageType } from "@/types";
import {
  handshakeMessageSenderLabel,
  isHandshakeAdminSentMessage,
} from "@/components/handshake/config";
import type { ChatMessage } from "../types";
import { forOutboundCustomerDisplay } from "./outboundCustomerDisplay";

export function mapHandshakeMessageToChatMessage(
  message: HandshakeMessagePublic,
  options: { sellerView: boolean; outboundCustomerLabel: string },
): ChatMessage {
  const { sellerView, outboundCustomerLabel } = options;

  if (message.sender_type === "SYSTEM") {
    if (message.system_type === SystemMessageType.OUTBOUND_CUSTOMER) {
      const { body, actions } = forOutboundCustomerDisplay(message.content);
      return {
        id: message.id,
        content: body,
        createdAt: message.created_at,
        role: "notice",
        senderLabel: outboundCustomerLabel,
        customerActions: actions.length > 0 ? actions : undefined,
      };
    }
    return {
      id: message.id,
      content: message.content,
      createdAt: message.created_at,
      role: "system",
    };
  }

  const isOwn =
    sellerView &&
    message.sender_type === "SELLER" &&
    !isHandshakeAdminSentMessage(message);

  const isBlocked = message.message_status === "BLOCKED";

  return {
    id: message.id,
    content: message.content,
    createdAt: message.created_at,
    role: isOwn ? "self" : "other",
    senderLabel: isOwn
      ? undefined
      : handshakeMessageSenderLabel(message),
    status: isBlocked ? "blocked" : "delivered",
    blockReason: message.block_reason,
    showReadReceipt: isOwn && !isBlocked,
  };
}
